// @ts-ignore
import store from "@/store"

async function handleLogInEvent() {}

async function handleLogOutEvent() {
  store.dispatch("providerRoles/clearProviderRoles")
}

export default {
  handleLogInEvent,
  handleLogOutEvent
}
